var _style, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtboard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 701 701.2",
    style: {
      enableBackground: "new 0 0 701 701.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6C2477;stroke:#FFFFFF;stroke-width:9.3814;stroke-miterlimit:4.8;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:45;stroke-miterlimit:4.8;}\n\t.st2{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 348.8,
    cy: 350.6,
    r: 344.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M456.6,306L348.8,166.9L241,306"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M357.9,411c-22.8,0-42.3,15.1-42.3,47.2s19.7,47.2,42.3,47.2c22.6,0,42.3-15.1,42.3-47.2S380.5,411,357.9,411z  M357.9,489.4c-13.6,0-25.4-9.5-25.4-31.3s12-31.2,25.4-31.2c13.6,0,25.4,9.5,25.4,31.2C383.3,480,371.3,489.4,357.9,489.4z  M229.5,412H296v15.7h-25v76.4h-16.7v-76.4h-25V412H229.5z M462,412h-33.8v92.1h16.7V468H462c19.1,0,28.1-11.9,28.1-28 S481.1,412,462,412z M461.4,452.4h-16.5V428h16.5c7.3,0,11.8,3.8,11.8,12.3S468.7,452.4,461.4,452.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtboard1);
export default __webpack_public_path__ + "static/media/Artboard 1.974f2167d4906ccbb3caa34c898b60bc.svg";
export { ForwardRef as ReactComponent };